import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { MessagingUserSettingOutput } from 'infrastructure/graphql/messaging/user/model/messaging-user-setting.output';

import { ApiQuery } from '../../../../common/model/api.query';

export interface FetchMessagingUserSettingsParams {
	readonly ownerId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchMessagingUserSettingsApiQuery extends ApiQuery<
	MessagingUserSettingOutput[],
	FetchMessagingUserSettingsParams
> {
	client = 'messaging';
	document = gql`
		query FetchUserSettings($ownerId: UUID!) {
			fetchUserSettings(ownerId: $ownerId) {
				property
				userId
				value
				type
			}
		}
	`;
	method = 'fetchUserSettings';
}
